export default __webpack_public_path__ + "static/V-ALI2_Voimakas_alivalotus-59c9e764b24fea68b4f7abf4d8667c4a.jpg";